import React from "react";
import  "dropzone";

export default class ImportRecordsStep extends React.Component{
  constructor(props){
    super(props)
    this.state={
      file_name: this.props.file_name || null,
      uploading: false,
      progress: 0,
    }

  };

  componentDidMount() {
    this.initDropzone();
  }

  componentDidUpdate(prevProps) {
    this.initDropzone();
  }

  initDropzone() {
    if (!this.refs['dropzone-input']) {
      return;
    }

    var self = this;
    var $dropzoneInput = $(this.refs['dropzone-input']);

    if ($dropzoneInput.hasClass('dz-clickable')) {
      return;
    }

    $dropzoneInput.dropzone({
      autoProcessQueue: true,
      url: '/admin/reports/csvs/new',
      uploadMultiple: false,
      paramName: `csv[upload]`,
      addedfile: function (file) {
        self.setState({ uploading: true, progress: 0});
        self.props.onChangeFileName(file.name)
      },
      uploadprogress: function (file, progress) {
        self.setState({ progress: progress });
      },
      success:  (file, response) =>{
        this.props.onFileUploaded(response.json.id, response.json.upload_file_name)
        this.setState({ uploading: false, progress: 100, errors: {} })
      },
      error: function (file, response) {
        // if (Object.keys(response).length) {
        //   self.setState({
        //     errors: response
        //   })
        // }
        self.setState({ uploading: false, progress: 100})
        self.props.onChangeFileName(null)
      }
    });

    /* dropzone visual cues when dragging */
    $dropzoneInput.on('dragover', function (e) {
      e.preventDefault();
      $(this).addClass('dragover');
    }).on('dragleave drop', function () {
      $(this).removeClass('dragover');
    });

    /* prevent window from loading dropped file that misses the dropzone */
    window.addEventListener("dragover", function (e) {
      e = e || event;
      e.preventDefault();
    }, false);

    window.addEventListener("drop", function (e) {
      e = e || event;
      e.preventDefault();
    }, false);
  }


  render(){
    return(
      <div className="row">
        <div className="col-md-12">
          <div className="image-group-builder">
            {/* <ModalButtons loading={this.state.loading} buttons={buttons} /> */}
            {/* {this.renderErrors()} */}
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading">
                <h3 className="panel-title pull-left">{I18n.t("csvs")} <span className="ss-help help" title={I18n.t("csvs_helper_text")}></span></h3>
                <div className="clearfix"></div>
              </div>
              <div className="panel-body">
                {this.renderDropzone()}
                {this.props.file_name ? this.renderFile() : null}
              </div>
            </div>
          </div>
          {/* <ImageBuilder
            upload_type="csv"
            dropzone_title="csvs"
            helperText="csvs_helper_text"
            click_text="click_or_drop_to_upload_csv"
            path={this.props.upload_path}
          /> */}
          {/* <UploadGroupBuilder 
            upload_type="csv" 
            upload_type_plural="csvs" 
            upload_groups={this.props.file_upload_group && this.props.new_record ? [this.props.file_upload_group] : this.props.file_upload_group && this.props.file_upload_group.file_uploads ? [{ csvs: this.props.file_upload_group.file_uploads }] : [{ csvs: [] }]} 
            onChange={this.props.onChangeFileUploadGroup} 
            // data_table_path={this.props.csvs_data_table_path} 
            multiple={false} 
            helperText={"csvs_helper_text"} 
            /> */}
        </div>
      </div>
    );
  };

  renderDropzone() {
    return (
      <div className="dropzone-container" data-dropzone-preview="image" key="dropzone">

        <div className="dropzone-image-spinner" style={{ display: this.state.uploading ? 'block' : 'none' }}>
          <div className="progress" style={{ width: this.state.progress + '%' }}></div>
          <i className="fa fa-3x fa-spinner fa-spin spinner"></i>
          {this.renderName()}
        </div>

        <div ref="dropzone-input" className="dropzone-input upload btn btn-lg btn-default btn-block" data-url={this.props.upload_path} data-name="csv" data-file-name="upload_file_name">
          {I18n.t("click_or_drop_to_upload_csv")}
        </div>
      </div>
    );
  };

  renderName() {
    if (this.props.file_name && this.state.progress == 100) {
      return <div className="name">{I18n.t('processing_and_saving')} {this.props.file_name}. {I18n.t('please_wait_ellipsis')}</div>
    } else if (this.props.file_name && this.state.progress != 100) {
      return <div className="name">{I18n.t('uploading')} {this.props.file_name} {I18n.t('ellipsis')}</div>
    };
  };

  renderFile() {
    return (
      <div
        className="sortable-image image-row row"
      >
        <div className="col-sm-2">{this.props.file_name}</div>
        <button type="button" className="btn btn-secondary" onClick={(e) => this.props.onChangeFileName(null)}>{I18n.t('remove')}</button>
      </div>
    );
  }

};